// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aa07fd9c","732":"c971ff33","977":"726fd4bf"}[chunkId] + ".chunk.js";
};